(function() {
  console.log('[Brooklyn upsell] Script loaded');

  const DEEP_SLEEP_HANDLE = 'orthopedic-calming-pet-bed-for-dogs-cats';
  const TITLE_KEYWORD = 'Deep Sleep';

  let lastCart = null;

  function getDeepSleepSizeFromCart(cart) {
    if (!cart || !Array.isArray(cart.items)) {
      console.log('[Brooklyn upsell] Cart is missing or has no items');
      return null;
    }

    console.log('[Brooklyn upsell] Cart items from UpCart hook:', cart.items);

    const deepSleepItems = cart.items.filter(function(item) {
      const byHandle = item.handle === DEEP_SLEEP_HANDLE;
      const byTitle =
        typeof item.product_title === 'string' &&
        item.product_title.toLowerCase().includes(TITLE_KEYWORD.toLowerCase());

      return byHandle || byTitle;
    });

    if (!deepSleepItems.length) {
      console.log('[Brooklyn upsell] No Deep Sleep items found in cart');
      return null;
    }

    const lastItem = deepSleepItems[deepSleepItems.length - 1];
    console.log('[Brooklyn upsell] Using Deep Sleep item:', lastItem);

    const vt = lastItem.variant_title || '';
    if (!vt) {
      console.log('[Brooklyn upsell] No variant_title on Deep Sleep item');
      return null;
    }

    const parts = vt.split('/');
    const sizeRaw = (parts[parts.length - 1] || '').trim();
    if (!sizeRaw) {
      console.log('[Brooklyn upsell] Could not parse size from variant_title:', vt);
      return null;
    }

    console.log('[Brooklyn upsell] Parsed size from cart:', sizeRaw);
    return sizeRaw;
  }

  function syncUpsellCoverToBedSize() {
    console.log('[Brooklyn upsell] syncUpsellCoverToBedSize called');

    const root = window.upcartDocumentOrShadowRoot || document;
    if (!root) {
      console.log('[Brooklyn upsell] No upcartDocumentOrShadowRoot available yet');
      return;
    }

    // Look for the upsell variant selects inside the UpCart drawer
    const selects = root.querySelectorAll(
      'select.upcart-upsell-item-variant-selector[name="productVariant"]'
    );

    console.log('[Brooklyn upsell] Upsell selects found inside UpCart root:', selects.length);

    if (!selects.length) {
      console.log('[Brooklyn upsell] No upsell variant select found inside UpCart root');
      return;
    }

    const size = getDeepSleepSizeFromCart(lastCart);
    if (!size) {
      console.log('[Brooklyn upsell] No Deep Sleep size available to sync');
      return;
    }

    const desiredSize = size.trim().toLowerCase();
    console.log('[Brooklyn upsell] Looking for cover option with size:', desiredSize);

    selects.forEach(function(select, index) {
      const options = Array.from(select.options || []);
      if (!options.length) {
        console.log('[Brooklyn upsell] Select #' + index + ' has no options');
        return;
      }

      let match = null;

      options.forEach(function(opt) {
        const text = (opt.text || '').trim(); // e.g. "Chalk Grey / L"
        const parts = text.split('/');
        const optSizeRaw = (parts[parts.length - 1] || '').trim().toLowerCase();

        if (optSizeRaw === desiredSize) {
          match = opt;
        }
      });

      if (!match) {
        console.log('[Brooklyn upsell] No matching option in select #' + index + ' for size', desiredSize);
        return;
      }

      if (select.value === match.value) {
        console.log('[Brooklyn upsell] Select #' + index + ' already correct for size', desiredSize);
        return;
      }

      console.log('[Brooklyn upsell] Setting select #' + index + ' to', match.text);
      select.value = match.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  // Expose for manual testing if you want
  window.brooklynUpsellSync = syncUpsellCoverToBedSize;

  // Hook into UpCart lifecycle
  const previousOnCartLoaded = window.upcartOnCartLoaded;

  window.upcartOnCartLoaded = function(cart) {
    console.log('[Brooklyn upsell] upcartOnCartLoaded fired');

    // preserve any existing handler
    if (typeof previousOnCartLoaded === 'function') {
      try {
        previousOnCartLoaded(cart);
      } catch (e) {
        console.error('[Brooklyn upsell] Error in previous upcartOnCartLoaded handler:', e);
      }
    }

    lastCart = cart;
    syncUpsellCoverToBedSize();
  };

  console.log('[Brooklyn upsell] UpCart hook wired (upcartOnCartLoaded)');
})();
